import React from "react";
import { useSelector } from "react-redux";

const ProfileUserDetail = () => {
  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );
  return (
    <div className="rounded p-2 my-3 profile-detail-container" style={{color:"#ffd700"}}>
      <p className="my-2 profile-user-email">
        <span className="bolded">E-Mail : </span>
        {get_profile?.email}
      </p>
      <p className="my-2 profile-user-phone">
        <span className="bolded">Mobile : </span>
        {get_profile?.phone}
      </p>
      <p className="my-2 profile-user-address">
        <span className="bolded">Address : </span>India
      </p>

      {/* <button className="w-100 btn btn-primary fw-bold my-2">
        Update Profile
      </button> */}
    </div>
  );
};

export default ProfileUserDetail;
